import { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions";
import { useLocation, useOutletContext } from "react-router-dom";
import { Http } from "../../../helpers/Http";
import MantUser from "./components/MantUser";
const MySwal = withReactContent(Swal);

const PageUser = () => {
    const location = useLocation();
       

    const [isRenderList, setIsRenderList] = useState(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
    const [idRef, setIdRef] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [tiposDocumento, setTiposDocumento] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [usuario, setUsuario] = useState(CONFIGURACIONES.INIT.NULL);
    const [colaborador, setColaborador] = useState(CONFIGURACIONES.INIT.NULL);
    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);
    const [zonas, setZonas] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [agencias, setAgencias] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [agenciasAsignadas, setAgenciasAsignadas] = useState(CONFIGURACIONES.INIT.ARRAY);

    const { getUser } = useOutletContext();
    const { showSpinnerLoader } = useOutletContext();

    const createUser = async (form) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
       
        await Functions().saveUser(`${CONFIGURACIONES.ENDPOINTS.USUARIOS}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), searchPerson, form);
    };

    const updateUser = async (form, id) => {
        //if (!searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)) { return; }

        await Functions().updateUser(`${CONFIGURACIONES.ENDPOINTS.USUARIOS}/${id}`, CONFIGURACIONES.MESSAGES.SUCCESS_UPDATE_OPERATION, getUser(), searchPerson, form);
    }

    const resetPassword = async (form) => {
        await Functions().saveUser(`${CONFIGURACIONES.ENDPOINTS.USUARIOS}/cambiar-clave`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), searchPerson, form);
    }

    const loadData = () => {
        Http().post(`${CONFIGURACIONES.ENDPOINTS.USUARIOS}/util/init`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setTiposDocumento(rpta.data.tiposDocumento);
                setZonas(rpta.data.zonas);
                setAgencias(rpta.data.agencias);
            }
        });
    };

    const searchPermissions = (action) => {
        let permisoStorage = localStorage.getItem('option_id');
        let tienePermiso = CONFIGURACIONES.INIT.STATUS_FALSE
        if (permisoStorage) {
            let permiso_id = Functions().decryptData(permisoStorage);
            tienePermiso = Functions().searchPermissions(permiso_id, action, getUser().permisos);
        }
        
        return tienePermiso;       
    };

    const searchPerson = () => {
        let tipoBusqueda = document.getElementById('tipoBusqueda').value;
        let tipoDocumentoId = document.getElementById('tipoDocumentoId')?.value;
        let numeroDocumento = document.getElementById('numeroDocumento')?.value;
        let usuario = document.getElementById('usuario')?.value;

        if (!tipoBusqueda) {
            MySwal.fire({
                title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                html: `Indique Tipo de búsqueda`,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
                cancelButtonColor: "#f62d51",
                confirmButtonColor: "#2962FF"
            });
            return;
        }

        let data = {
            body: {
                'tipoBusqueda': tipoBusqueda,
                'tipoDocumentoId': tipoDocumentoId,
                'numeroDocumento': numeroDocumento,
                'usuario': usuario
            }
        }
        
        if (tipoBusqueda === CONFIGURACIONES.INIT.TYPE_BQ_U) {
            if (usuario) {
                setUsuario(CONFIGURACIONES.INIT.NULL);
                setColaborador(CONFIGURACIONES.INIT.NULL);
                Http().post(`${CONFIGURACIONES.ENDPOINTS.USUARIOS}/obtener-empleado`, data).then((rpta) => {
                    if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                        setUsuario(rpta.data.usuario);
                        setColaborador(rpta.data.empleado);
                        setAgenciasAsignadas(rpta.data.agencias);
                    } else {
                        MySwal.fire({
                            title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                            html: `${Object.keys(rpta.errors).length?Functions().showErrors(rpta.errors):rpta.message}`,
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            cancelButtonColor: "#f62d51",
                            confirmButtonColor: "#2962FF"
                        });
                    }
                });
            } else {
                MySwal.fire({
                    title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                    html: `Indique <strong>Usuario</strong> para realizar búsqueda`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                });
            }
           
        } else if (tipoBusqueda === CONFIGURACIONES.INIT.TYPE_BQ_C) {
            if (tipoDocumentoId && numeroDocumento) {
                setUsuario(CONFIGURACIONES.INIT.NULL);
                setColaborador(CONFIGURACIONES.INIT.NULL);
                Http().post(`${CONFIGURACIONES.ENDPOINTS.USUARIOS}/obtener-empleado`, data).then((rpta) => {
                    if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                        setUsuario(rpta.data.usuario);
                        setColaborador(rpta.data.empleado);
                        setAgenciasAsignadas(rpta.data.agencias);
                    } else {
                        MySwal.fire({
                            title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                            html: `${Object.keys(rpta.errors).length?Functions().showErrors(rpta.errors):rpta.message}`,
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            cancelButtonColor: "#f62d51",
                            confirmButtonColor: "#2962FF"
                        });
                    }
                });
            } else {
                MySwal.fire({
                    title:  `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                    html: `Indique <strong>Tipo de Documento</strong> y <strong>Número de Documento</strong> para realizar búsqueda`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                });
            }
        }
    }

    useEffect(() => {
        const icon = localStorage.getItem('icon_active');
        if (icon) {
            const icon_decrypt = Functions().decryptData(icon);
            setIconActive(icon_decrypt);
        }
    }, []); // se ejecuta una vez al montar

    useEffect(() => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.MOSTRAR)) { return; }
        
        showSpinnerLoader();
        loadData();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSegment', lastSegment);
        // loadData();
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        // console.log(`result: ${lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')}`);
        // console.log('componentes', componentes);
        
    }, [location.pathname])
    
    return (
        <div className="content-wrapper">
            <div className="content-body"> 
                <div className="row">
                    {isRenderList && (
                        <div className="col-lg-10 col-md-12 col-xs-12">
                            <div className="card">
                                <div className="card-body">
                                    <MantUser title={'Gestión de Usuarios'} idEdit={idRef} MySwal={MySwal} setUsuario={setUsuario} setColaborador={setColaborador} icon={iconActive}
                                        setIdRef={setIdRef} usuario={usuario} colaborador={colaborador} tiposDocumento={tiposDocumento} fnBuscar={searchPerson} fnCrear={createUser} 
                                        fnReset={resetPassword} showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} showReset={searchPermissions(CONFIGURACIONES.ACTIONS.RESETEAR)} 
                                        showDelete={searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)} zonas={zonas} agencias={agencias} fnActualizar={updateUser} agenciasAsignadas={agenciasAsignadas} />
                                </div>
                            </div>
                        </div>
                    )}
                       
                </div>
            </div>
        </div>
    )
}

export default PageUser;